import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    description: (days: number) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Setting title for asset lifecycle policy */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAssetPolicyToggle.title?c=rbvv0xiz5bfp", defaultMessage: "Asset Lifecycle" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for asset lifecycle timing */
            description: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (days: number) => __intl__.intl().formatMessage({ id: "ProjectAssetPolicyToggle.description?c=1xyqldp8cksg7", defaultMessage: "{days, plural, one {Auto-delete assets 1 day after upload date.} other {Auto-delete assets {days} days after upload date}}" }, { days: days }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
